import { NgModule, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';

// components
import { InsuredEsignComponent } from './insured-esign.component';

// modules
import { LoadingModule } from '../../../../../coverpath-common/angular/components/shared/loading/loading.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CpFormFieldModule } from '../../../../../coverpath-common/components/form-field/form-field.module';

@NgModule({
  declarations: [InsuredEsignComponent],
  imports: [LoadingModule, CommonModule, FormsModule, ReactiveFormsModule, CpFormFieldModule],
  exports: [InsuredEsignComponent],
  providers: [],
  bootstrap: [InsuredEsignComponent],
})
export class InsuredEsignModule {
  /**
   * Allows for retrieving singletons using `AppModule.injector.get(MyService)`
   * (whereas `ReflectiveInjector.resolveAndCreate(MyService)` would create a
   * new instance of the service).
   */
  static injector: Injector;
  constructor(injector: Injector) {
    InsuredEsignModule.injector = injector;
  }
}
